<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <PlaceMediaForm
      v-if="!isLoading"
      :placeMediaData="placeMediaData"
      :mediaSrc="mediaSrc"
      :submitName="$t('add')"
      v-on:addOrUpdatePlaceMedia="addPlaceMedia"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import PlaceMediaForm from "@/components/places/placesMedias/PlaceMediaForm.vue";
import PlaceMedia from "@/models/places/placesMedias/PlaceMedia";
import DEFAULT_IMG from "@/assets/images/places-media.svg";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "PlaceMediaAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    PlaceMediaForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      placeMediaData: new PlaceMedia(),
      mediaSrc: DEFAULT_IMG,
    };
  },
  methods: {
    async addPlaceMedia() {
      this.isLoading = true;
      try {
        let response = await this.placeMediaData.addOrUpdatePlaceMedia(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.placeMediaData.setInitialValue();
          this.placeMediaData.placeToken = this.$route.params.placeToken;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.placeMediaData.placeToken = this.$route.params.placeToken;
  },
};
</script>

<style scoped lang="scss"></style>
